import { render } from "./Jobdetails.vue?vue&type=template&id=515c9760&scoped=true"
import script from "./Jobdetails.vue?vue&type=script&lang=js"
export * from "./Jobdetails.vue?vue&type=script&lang=js"

import "./Jobdetails.vue?vue&type=style&index=0&id=515c9760&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515c9760"]])

export default __exports__